import { ElementType } from 'react';
import { Link } from 'react-router-dom';
import { NavItem } from 'interfaces/NavTypes';

type Props = {
  key: string;
  component: ElementType;
  href?: string;
  to?: string;
};

type GetRouteProps = (item: NavItem) => Props;

export const getRouteProps: GetRouteProps = ({ title, translation_key, route }) => {
  const props: Props = {
    // A static label carries no title of its own, so fall back to its key and then
    // to the route. All three are stable per item; the key just has to be defined.
    key: translation_key ?? title ?? route,
    component: Link,
  };

  if (route && route.match(/^http/)) {
    props.href = route;
    props.component = 'a';
  } else {
    props.to = route;
  }

  return props;
};
